export const ENV_CONFIG = {
  php1Url: process.env.REACT_APP_API_apiUrlemis1 ?? '',
  php3Url: process.env.REACT_APP_API_apiUrlemis3 ?? '',
  mobileUrlphp: process.env.REACT_APP_API_apibaseurlemis4 ?? '',
  djangoTnEmisUrl: process.env.REACT_APP_API_apiUrlTnEmisDjango ?? '',
  djangoEmisUrl: process.env.REACT_APP_API_apiUrlEmisDjango ?? '',
  // Institute (Coaching Centre) Django app — mounted at /api/institute/ on the
  // same host as the TN-EMIS Django API (/api/tnemis/). Falls back to deriving
  // it from the TN-EMIS URL when its own env var isn't set.
  djangoInstituteUrl: process.env.REACT_APP_API_apiUrlInstituteDjango ?? '',
  menuJsonUrl: process.env.REACT_APP_API_menuJson ?? '',
  emisLoginUrl: process.env.REACT_APP_API_loginApiBaseUrl ?? '',
  emisAuthUrl: process.env.REACT_APP_API_loginAuthorization ?? '',
  DjangoSupportUrl: process.env.REACT_APP_API_apiBasedjangoSupport ?? '',
  siteBaseURL: process.env.REACT_APP_API_siteBaseURL ?? '',
  emis_login: process.env.REACT_APP_API_loginApiBaseUrl ?? '',
  smcSiteURL: process.env.REACT_APP_API_smcSiteURL ?? '',
  slasSiteURL: process.env.REACT_APP_API_slasSiteURL ?? '',
  cmsMS: process.env.REACT_APP_API_cmsMS ?? '',
  // Angular: environment.smcImageBaseUrl1 — CloudFront host that serves the
  // stage/status photo and voucher images stored as bare keys in the API.
  smcImageBaseUrl1: process.env.REACT_APP_API_smcImageBaseUrl1 ?? '',
  // CloudFront host serving coaching-centre uploaded documents. The *_doc
  // columns store only the filename; the viewer builds the URL as
  // <base> + <pdf|images folder> + <filename> (see CoachingCentreApprovalDetail).
  // Mirrors react-coaching-fe/src/api/upload.js.
  coachingDocBaseUrl:
    process.env.REACT_APP_API_coachingDocBaseUrl ??
    'https://d21mc000xink7q.cloudfront.net/',
  // g2c PHP API base — hosts the coaching-centre eSign endpoint that returns
  // { txn, signXML } for the CDAC browser-redirect handoff.
  g2cUrl: process.env.REACT_APP_API_g2cUrl ?? '',
  nsNopUrl: process.env.REACT_APP_API_apiUrlNsNop ?? '',
  nsNopEmisUrl: process.env.REACT_APP_API_apiUrlNsNopEmisUrl ?? '',
  // API key for the emisext AWS API Gateway host (nsNopEmisUrl). That gateway
  // accepts `x-api-key` only — no Bearer token, no Authorization header.
  emisExtApiKey: process.env.REACT_APP_EMIS_EXT_API_KEY ?? '',
  emisExtUrl: process.env.REACT_APP_API_apiBaseUrl4 ?? '',
  // Angular: environment.apiBaseUrl1 — AWS API Gateway (emis-prod) used by
  // DataService.getDataSample (e.g. the student e-learn /etbqr QR lookup).
  emisSampleUrl: process.env.REACT_APP_API_apiBaseUrl1 ?? '',
};

export default ENV_CONFIG;
